import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { getJiraIssuesSlice } from './get';

export const jiraIssuesReducers = combineReducers({
	get: getJiraIssuesSlice.asyncReducers
});

export const jiraIssuesWatchers = combineAllWatchers([
	getJiraIssuesSlice.asyncWatchers
]);
